import { useState, useEffect } from "react";
import { MainPageBase } from "../page-bases/MainPageBase";
import { Box, Stack } from "@mui/material";
import { TRowItem } from "../../components/Table/TableRow";
import DamsTable from "../../components/Table/CollapsibleTable";

import {
  AssetAssignmentLog,
  IPagination,
  IQueryPerams,
} from "../../config/types";
import { useMangeTableItems } from "../../hooks/useManageTableItems";

import { formatDate } from "../../utils/common";
import { assignmentApi } from "../../services/assets/asset-assignment";
import { usePagination } from "../../hooks/usePagination";

const AssetsInMyPossessionPage = () => {
  const [dataset, setDataset] = useState<TRowItem[]>([]);

  const {
    selectedRowItems,
    toggleRow,
    toggleSelectAllRow,
    resetSelectedRowItems,
  } = useMangeTableItems(dataset);
  const {
    pagination,
    paginateToNextPage,
    paginateToPreviousPage,
    paginateToPageNumber,
    updatePaginationInitState,
  } = usePagination<AssetAssignmentLog[]>(
    assignmentApi.getAssignmentsInPossession
  );

  const [querySet] = useState<IQueryPerams>({ is_deleted: false });
  const populateDataSet = (
    data: AssetAssignmentLog[],
    pagination?: IPagination
  ) => {
    const formatted_data = data.map((record) => ({
      ...record,
      asset_brand: `${record.asset_brand}(${record.asset_model})`,
      user_email: `${record.user_email}  (${record.user_first_name + record.user_last_name})`,
      created_at: formatDate(record.created_at),
    }));
    setDataset(formatted_data);
    updatePaginationInitState(pagination);
  };
  const fetchData = async () => {
    const result = await assignmentApi.getAssignmentsInPossession();

    if (result?.data) {
      populateDataSet(result.data, result.pagination);
    }
  };
  useEffect(() => {
    fetchData();
    resetSelectedRowItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MainPageBase
      pageState={"main"}
      title={"Assets in My Possession"}
      subtitle={
        "A list of assets you are responsible for and currently in possession of."
      }
      exportBtnOnClick={() => {
        alert("Exporting...");
      }}
      exportBtnText={"Export"}
    >
      <Box
        height={`100%`}
        display={"flex"}
        justifyContent={"center"}
      >
        <Stack width={"100%"}>
          <DamsTable
            tableTitle="Asset Assignment Logs"
            tableSubtitle="Logs of accepted and currently held assets"
            numTableRecords="25"
            tableHeaders={columns}
            tableKeys={tkeys}
            data={dataset}
            maxRowCells={6}
            hiddenKeys={hkeys}
            hiddenLabels={hcolumns}
            useTableCheckbox
            onTableItemSelect={toggleRow}
            toggleSelectAllRow={toggleSelectAllRow}
            selectedRowItems={selectedRowItems}
            hasPagination
            paginationState={pagination}
            onNextPage={paginateToNextPage(querySet, populateDataSet)}
            onPreviousPage={paginateToPreviousPage(querySet, populateDataSet)}
            setActivePage={paginateToPageNumber(populateDataSet,querySet)}
          />
        </Stack>
      </Box>
    </MainPageBase>
  );
};


const tkeys: (keyof AssetAssignmentLog)[] = [
  "asset_brand",
  "asset_serial_number",
  "user_email",
  "user_category",
  "asset_assignment_status",
  "created_at",
];

const columns = [
  "Asset Brand (Model)",
  "Serial Number",
  "Assigned User - Email (Full Name)",
  "User Category",
  "Assignment Status",
  "Date of Assignment",
];
const hkeys: (keyof AssetAssignmentLog)[] = [
  "remarks",
  "asset_current_location",
  "user_domain",
];

const hcolumns = ["Remarks", "Asset Current Location", "User Domain"];

export default AssetsInMyPossessionPage;
